import { render } from "./quoted-price-list.vue?vue&type=template&id=a12881fc"
import script from "./quoted-price-list.vue?vue&type=script&lang=js"
export * from "./quoted-price-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__